export default class {

    constructor ($translate, lodash, ModalService, MomentService, USER_STATUS_ENUM, ROLE_CODE_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.ModalService = ModalService;
        this.MomentService = MomentService;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
    }

    editRoles (subject, itemIds, userAssignments, removeMissingRoles, context) {
        return this.ModalService.open({
            template: `<modals-manage-role on-close="vm.$uibModalInstance.dismiss()"
                on-update="vm.update()" remove-missing-roles="vm.removeMissingRoles"
                user-assignments="vm.userAssignments" item-ids="vm.itemIds"
                subject="vm.subject" context="vm.context" class="wrapper" />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.subject = subject;
                this.itemIds = itemIds;
                this.userAssignments = userAssignments;
                this.removeMissingRoles = removeMissingRoles;
                this.context = context;
                this.update = () => {
                    this.$uibModalInstance.close();
                };
            }
        });
    }

    viewPrivileges (user, siteId) {
        this.ModalService.open({
            template: `<modals-manage-privilege on-close="vm.$uibModalInstance.dismiss()"
            site-id="vm.siteId" user="vm.user" class="wrapper" />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.siteId = siteId;
                this.user = user;
            }
        });
    }

    isActive (user) {
        return user.status === this.USER_STATUS_ENUM.KEYS.ACTIVE;
    }

    getStatusLabel (user) {
        if (user.status !== this.USER_STATUS_ENUM.KEYS.NOT_STARTED) {
            return this.USER_STATUS_ENUM.LABELS[user.status];
        }
        return this.$translate.instant('user.Starting {workingSince}', { workingSince: this.MomentService.formatDate(user.workingSince) });
    }

    isCompanyManager (userAssignments) {
        return this.lodash.filter(userAssignments, (assignment) =>
            this.lodash.includes(assignment.privilegesJson, 'COMPANY_MANAGE')).length;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/user/index.js